import KeyboardBackspaceIcon from "@material-ui/icons/KeyboardBackspace";
import React from "react";
import { useHistory, useLocation } from "react-router-dom";
import { ReactComponent as Logo } from "../images/Curves_Logotype_RGB_Neon_Green.svg";
import styles from "./Header.module.scss";
import LanguageSwitcher from "./LanguageSwitcher";
import { createSelector } from "reselect";
import UserInfo from "./UserInfo";
import { IApplicationState } from "../../redux/root-reducer";
import { isLandlordTypeGuard } from "../models/userInfo";
import { useDispatch, useSelector } from "react-redux";

const headerState = createSelector(
  (state: IApplicationState) => state.common,
  (commonState) => isLandlordTypeGuard(commonState.currentUserInfo)
);

const Header: React.FC = () => {
  const history = useHistory();
  const isLandlord = useSelector(headerState);
  const location = useLocation();

  const goBack = () => {
    if (isLandlord && location.pathname === "/") {
      return;
    }
    if (
      !isLandlord &&
      location.pathname.includes("safetySensors") &&
      !location.pathname.includes("consumptionDetails")
    ) {
      return;
    }

    history.goBack();
  };
  return (
    <>
      <div className={styles.container}>
        <div className={styles.goBackButton} onClick={() => goBack()}>
          <KeyboardBackspaceIcon fontSize={"large"}></KeyboardBackspaceIcon>
        </div>
        <div className={styles.headlineContainer}>
          <Logo className={styles.headline} />
        </div>
        <LanguageSwitcher />
      </div>
      <div>
        <UserInfo />
      </div>
    </>
  );
};

export default Header;
